<template>
  <DatePicker
    transfer
    type="daterange"
    format="yyyy-MM-dd"
    :placeholder="placeholder"
    @on-change="change_times"
  ></DatePicker>
</template>

<script>
import { getParams } from "./utils";
export default {
  props: {
    placeholder: {
      type: String,
      default: "请选择时间"
    },
    param: {
      type: Object,
      default: () => {
        return {
          filter: "a.verifytime",
          op: "BETWEEN"
        };
      }
    }
  },
  data() {
    return {
      times: ""
    };
  },
  watch: {
    times(val) {
      let params = getParams(this.param.filter, val, this.param.op);
      console.log(params);
      this.$emit("get", params, Boolean(val));
    }
  },
  methods: {
    change_times(val) {
      console.log(val);
      if (val[0]) {
        this.times = val.join(",");
      } else {
        this.times = "";
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/basic-filter/BaseTimes.vue